export type RecurrenceFrequency = 'daily' | 'weekly' | 'monthly' | 'yearly'

export type IsoWeekday = 1 | 2 | 3 | 4 | 5 | 6 | 7

export type NthWeekdayPosition = 1 | 2 | 3 | 4 | -1

export interface NthWeekday {
  position: NthWeekdayPosition
  weekday: IsoWeekday
}

export type MonthlyMode = 'day-of-month' | 'nth-weekday'

export type EndCondition = { kind: 'never' } | { kind: 'after'; count: number } | { kind: 'on'; date: string }

export interface RecurrenceRule {
  frequency: RecurrenceFrequency
  interval: number
  weekDays?: IsoWeekday[]
  monthDay?: number
  monthlyMode?: MonthlyMode
  nthWeekday?: NthWeekday
  endCondition?: EndCondition
  periodic?: boolean
  endDate?: string
  endAfter?: number
}

export function normalizeRule(rule: RecurrenceRule): RecurrenceRule {
  const normalized: RecurrenceRule = { ...rule }

  if (!normalized.endCondition) {
    if (typeof normalized.endAfter === 'number' && normalized.endAfter > 0) {
      normalized.endCondition = { kind: 'after', count: normalized.endAfter }
    } else if (normalized.endDate) {
      normalized.endCondition = { kind: 'on', date: normalized.endDate }
    } else {
      normalized.endCondition = { kind: 'never' }
    }
  }

  if (normalized.frequency === 'monthly' && !normalized.monthlyMode) {
    normalized.monthlyMode = normalized.nthWeekday ? 'nth-weekday' : 'day-of-month'
  }

  return normalized
}
